<!--
   Created by Terence on 2023/2/21 - 16:34
-->
<template>
  <div
    v-if="suspectedCount"
    :class="`suspect ${isDanger ? 'suspect--danger' : ''}`"
    @click="handleToSuspect"
  >
    <span class="suspect-text">{{ suspectedCount }}位用户对该作品提出疑议</span>
    <img
      class="arrow"
      v-if="isDanger"
      src="https://cdn.qiandaoapp.com/interior/images/536157afb1c1324aa6c3f70702724522.png"
      alt=""
    />
    <img
      class="arrow"
      v-else
      src="https://cdn.qiandaoapp.com/interior/images/fd0a96ed5b3c8bd9177917a47ff6a913.png"
      alt=""
    />
  </div>
</template>

<script setup>
import { defineProps, computed, inject } from "vue";
import { useRouter } from "vue-router";

const router = useRouter();

const tokenId = inject("tokenId");

const props = defineProps({
  suspectedCount: {
    type: Number,
    default: 0,
  },
});

const isDanger = computed(() => {
  return props.suspectedCount >= 3;
});

const handleToSuspect = () => {
  router.push(`/suspect-detail?tokenId=${tokenId.value}`);
};
</script>

<style lang="scss" scoped>
.suspect {
  position: sticky;
  top: 0;
  margin: 0 auto;
  display: flex;
  width: 690rpx;
  padding: 20rpx 30rpx;
  justify-content: center;
  align-items: center;
  border-radius: 16rpx;
  background: #ffebe9;
  &-text {
    color: #d94a4e;
    font-size: 24rpx;
    font-weight: 500;
    line-height: 36rpx; /* 150% */
  }
  .arrow {
    margin-left: 4rpx;
    width: 16rpx;
    height: 16rpx;
  }
}
.suspect--danger {
  background-color: #d94a4e;
  .suspect-text {
    color: #ffebe9;
  }
}
</style>

<!--v-model	min max step-->
